import type { BaseSyntheticEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../types';
import { StyledButton } from '../legacy/components/ui/Menu/style';
import { MapIcon } from '../design_system/icons/MapIcon';
import { NavigateToRoadSectionOnMapCommand } from '../../core/networkMap/commands/NavigateToRoadSectionOnMapCommand';

type Props = {
    line: [number, number][];
    overallRate?: number | null;
};

export const ViewSectionOnMapButton: FC<Props> = ({ line, overallRate }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const handleClick = (event: BaseSyntheticEvent) => {
        event.stopPropagation();
        dispatch(NavigateToRoadSectionOnMapCommand({ line, overallRate }));
    };

    return (
        <StyledButton onClick={handleClick} type="button">
            <MapIcon title={t('labels.networkMap')} themeStyle="light" size="tableIconSize" />
        </StyledButton>
    );
};
